angular.module('jv.Common.Jobvite.Urls', [])
	.config(['$provide', function($provide) {
		if (typeof jvUrls === 'undefined') {
			throw new Error('No global variable "jvUrls" found! Please provide it.');
		}
		$provide.constant('$jobviteUrls', jvUrls);
	}]);
